import { FC } from 'react';
import './AnswerMessage.scss';
import { Spinner } from '@fluentui/react-components';

export const AnswerLoading: FC = () => {
    return (
        <div className='answerMessage'>
            <div className='inner'>
                <div className='content only-spinner'>
                    <Spinner appearance='primary' label='' />
                </div>
            </div>
        </div>
    );
};
